import React from 'react';
import { Col } from 'reactstrap';

const HERO_FEATURES = [
  {
    icon: 'ri-ship-2-line',
    tone: 'blue',
    title: 'Tender & Award Management',
    desc: 'End-to-end tender execution & awarding',
  },
  {
    icon: 'ri-shield-keyhole-line',
    tone: 'indigo',
    title: 'Secure Access',
    desc: 'Enterprise-grade authentication',
  },
  {
    icon: 'ri-links-line',
    tone: 'teal',
    title: 'Verified Vendor Eligibility',
    desc: 'Seamless integration with certified registered vendors',
  },
];

const AuthSlider = () => {
  return (
    <Col lg={6} className='d-none d-lg-block'>
      <div className='login-hero h-100'>
        <div className='login-hero-overlay' />
        <div className='login-hero-accent' />
        <div className='login-hero-content d-flex flex-column h-100 p-lg-5 p-4'>
          <div className='d-flex align-items-center'>
            <span className='login-hero-version'>V1.0</span>
          </div>

          <div className='mt-auto'>
            <div className='login-hero-eyebrow mb-3'>
              <i className='ri-anchor-line' />
              Hydrocarbon &amp; Energy Procurement
            </div>
            <h2 className='login-hero-title text-white mb-3'>
              HYROC
              <span>Digital Hydrocarbon Procurement</span>
            </h2>
            <p className='login-hero-desc mb-4'>
              Streamline procurement operations across Pertamina Patra
              Niaga&apos;s hydrocarbon supply chain with a unified, secure
              enterprise platform.
            </p>

            <div className='login-hero-features'>
              {HERO_FEATURES.map(item => (
                <div className='login-feature-card' key={item.title}>
                  <div
                    className={`login-feature-icon login-feature-icon--${item.tone}`}
                  >
                    <i className={item.icon} />
                  </div>
                  <div>
                    <div className='login-feature-title'>{item.title}</div>
                    <div className='login-feature-desc'>{item.desc}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </Col>
  );
};

export default AuthSlider;
